import { useQueryParams } from "./useQueryParams";

export const useIsNoAssign = () => {
  const queryParams = useQueryParams();
  const filter = queryParams.get('filter');

  return filter === 'noassign'
}